import React from 'react'
import { useRetorikStore } from '../../Contexts/RetorikContext'
import { useLocaleStore } from '../../Contexts/LocaleContext'
import { useDirectlineStore } from '../../Contexts/DirectlineContext'

import { capitalizeFirstLetter } from '../../../utils/capitalizeFirstLetter'

import HomeIcon from '../../Icons/RemoteIcons/HomeIcon'
import DashboardColumn from './DashboardColumn'

interface DashboardProps {
  toggleDashboard: () => void
}

const Dashboard = ({ toggleDashboard }: DashboardProps): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)
  const locale = useLocaleStore((state) => state.locale)
  const menus = useRetorikStore((state) => state.configuration.menu)
  const sendEvent = useDirectlineStore((state) => state.actions.sendEvent)

  const handleHome = (): void => {
    sendEvent('showHome')
    toggleDashboard()
  }

  return (
    <div className='rf-w-full rf-px-5 rf-pt-4 rf-flex rf-flex-col rf-justify-start'>
      {/* Home */}
      <div
        className='rf-relative rf-w-full rf-py-3 rf-flex rf-flex-row rf-items-center rf-flex-nowrap rf-gap-2 hover:rf-cursor-pointer rf-rounded rf-text-trueblack rf-overflow-hidden'
        onClick={handleHome}
      >
        <HomeIcon className='rf-h-6 rf-w-8' color='#1999B1' />
        <div>{capitalizeFirstLetter(translation['1'], locale)}</div>
      </div>

      {/* Other menus */}
      {menus?.categories?.map((menu, key) => {
        return (
          <React.Fragment key={key}>
            <div className='rf-h-6 -rf-mx-8 rf-bg-[#F0F0F0] rf-border-y rf-border-y-menuBorder' />
            <DashboardColumn {...menu} onClick={toggleDashboard} />
          </React.Fragment>
        )
      })}
    </div>
  )
}

export default Dashboard
